(() => {
  if (customElements.get('dugnado-extras')) return;
  class DugnadoExtras extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      this.rank();
      if (this.dataset.mode !== 'cart') return;
      const main = document.querySelector('#main-content');
      if (!main) return;
      this.observer = new MutationObserver(records => {
        if (!records.some(r => {const target=r.target.nodeType===1?r.target:r.target.parentElement;return target?.closest('.cart-page-section')&&!target.closest('dugnado-extras');})) return;
        clearTimeout(this.refreshTimer); this.refreshTimer = setTimeout(() => this.refresh(), 250);
      });
      this.observer.observe(main, {childList:true,subtree:true,characterData:true});
    }
    disconnectedCallback() {this.observer?.disconnect();clearTimeout(this.refreshTimer);this.request?.abort();}
    money(cents) {return new Intl.NumberFormat('nb-NO',{style:'currency',currency:this.dataset.currency || 'NOK',maximumFractionDigits:2}).format(cents/100);}
    rank() {
      const cards = [...this.querySelectorAll('[data-extra-card]')];
      if (!cards.length) {this.hidden=true;return;}
      this.hidden=false;
      if (this.dataset.mode !== 'cart') return;
      if (this.dataset.currency !== 'NOK') {this.hidden=true;return;}
      const gap = Math.max(0,Number(this.dataset.goal)-Number(this.dataset.total));
      cards.sort((a,b) => {
        const priority=Number(a.dataset.priority)-Number(b.dataset.priority);
        if (priority) return priority;
        if (!gap) return Number(a.dataset.price)-Number(b.dataset.price);
        const ap=Number(a.dataset.price),bp=Number(b.dataset.price),af=ap>=gap && a.dataset.options==='false',bf=bp>=gap && b.dataset.options==='false';
        if (af!==bf) return af ? -1 : 1;
        return af ? ap-bp : bp-ap;
      });
      const grid=this.querySelector('[data-extras-grid]');
      cards.forEach((card,i) => {
        card.hidden=i>=4;grid.append(card);
        const label=card.querySelector('[data-extra-gap]');
        if (!label) return;
        if (!gap) {label.textContent='';return;}
        if (card.dataset.options==='true') label.textContent=this.dataset.choose;
        else if (Number(card.dataset.price)>=gap) label.textContent=this.dataset.crosses;
        else label.textContent=this.dataset.left.replace('[amount]',this.money(gap-Number(card.dataset.price)));
      });
    }
    async refresh() {
      this.request?.abort(); this.request=new AbortController();
      const url=new URL(this.dataset.cartUrl,window.location.origin);url.searchParams.set('section_id',this.dataset.sectionId);
      try {
        const response=await fetch(url,{credentials:'same-origin',signal:this.request.signal});if(!response.ok) throw new Error('section');
        const html=new DOMParser().parseFromString(await response.text(),'text/html');const next=html.querySelector('dugnado-extras');if(!next) throw new Error('section');
        this.innerHTML=next.innerHTML;this.dataset.total=next.dataset.total;this.rank();
      } catch (e) {
        if (e.name==='AbortError') return;
        const status=this.querySelector('[data-extras-status]');if(status) status.textContent=this.dataset.unavailable;
        this.querySelector('[data-extras-grid]')?.setAttribute('hidden','');
      }
    }
  }
  customElements.define('dugnado-extras',DugnadoExtras);
})();
